//import Nav from 'react-bootstrap/Nav'
import { Link } from 'react-router-dom'
import { specArray } from '../services/arrays'
import { getInjuryBadge } from '../services/injury'

const PlayerOnList = ({ player, onRemove }) => {
  const tyhja = 0
  const vali = ' '
  const playerRouteId = player.isCustom ? player.id : player.playerId
  const injuryBadge = getInjuryBadge(player)
  const formatSkill = skill => {
    const value = Number(skill)
    return Number.isNaN(value) ? tyhja : value.toFixed(2)
  }

  // Funktio todellisen iän laskemiseksi
  // Hattrickissä 1 päivä = 1 oikea päivä, mutta 1 vuosi = 112 päivää
  const calculateActualAge = player => {
    if (!player.dateUpdated) {
      return { years: player.age, days: player.ageDays }
    }

    const now = new Date()
    const updated = new Date(player.dateUpdated)
    const daysPassed = Math.floor((now - updated) / (1000 * 60 * 60 * 24))

    let totalDays = player.ageDays + daysPassed
    let totalYears = player.age

    while (totalDays >= 112) {
      totalDays -= 112
      totalYears += 1
    }

    return { years: totalYears, days: totalDays }
  }

  const actualAge = calculateActualAge(player)
  return (
    <tr align="center">
      <td>
        <Link
          to={`/players/${playerRouteId}`}
          style={{ textDecoration: 'none', color: 'white' }}
        >
          <div>
            {player.firstName}
            {vali}
            {player.lastName}
            {injuryBadge && (
              <span
                title={injuryBadge.title}
                style={{
                  marginLeft: '6px',
                  color: injuryBadge.icon === '❌' ? '#e74c3c' : '#f1c40f',
                  fontWeight: 'bold',
                  whiteSpace: 'nowrap',
                }}
              >
                {injuryBadge.text}
              </span>
            )}
          </div>
        </Link>
      </td>
      <td>
        {actualAge.years}.{actualAge.days}
      </td>
      <td>{specArray[player.specialty]}</td>
      <td>{formatSkill(player.playerSkills.keeperSkill)}</td>
      <td>{formatSkill(player.playerSkills.defenderSkill)}</td>
      <td>{formatSkill(player.playerSkills.playmakerSkill)}</td>
      <td>{formatSkill(player.playerSkills.wingerSkill)}</td>
      <td>{formatSkill(player.playerSkills.passingSkill)}</td>
      <td>{formatSkill(player.playerSkills.scorerSkill)}</td>
      <td>{formatSkill(player.playerSkills.setPiecesSkill)}</td>
      {onRemove && (
        <td>
          <button
            onClick={() => onRemove(player.id)}
            style={{ color: 'red', cursor: 'pointer' }}
          >
            Poista
          </button>
        </td>
      )}
    </tr>
  )
}

export default PlayerOnList
